import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { criarRoteador } from './rotas';
import { aplicar, lerLocal } from './lib/acessibilidade';
import { ProvedorDeMovimento } from './componentes/ProvedorDeMovimento';
import { Avisador } from './componentes/ui/Avisador';
import { AvisoAtualizacao } from './componentes/AvisoAtualizacao';
import './estilo.css';

// O script inline do index.html ja aplicou as preferencias; reaplicamos aqui
// para o caso de o inline ter falhado (CSP estrita, extensao bloqueando).
aplicar(lerLocal());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

const roteador = criarRoteador(queryClient);
const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html');

// Modo assistente da Ana: ela opera o app pela pessoa (só na área de contratar).

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorDeMovimento>
        <Avisador>
          <RouterProvider router={roteador} />
          <AvisoAtualizacao />
        </Avisador>
      </ProvedorDeMovimento>
    </QueryClientProvider>
  </StrictMode>,
);
